import React, { useEffect, useState } from 'react';
import { ContentHeader, Table } from '@app/shared';

import { useAccountTreatmentIndicators } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../../components/MasterDetailLayout';
import { AccountTreatmentIndicatorForm } from './AccountTreatmentIndicatorForm';
import { Segment } from 'semantic-ui-react';

export function AccountTreatmentIndicators() {
  const [selectedAccountTreatmentIndicator, setSelectedAccountTreatmentIndicator] = useState(undefined as any);
  const { data: accountTreatmentIndicators } = useAccountTreatmentIndicators();
  const [accountTreatmentIndicator, setAccountTreatmentIndicator] = useState();
  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Id' },
    { field: 'name', headerName: 'Name' },
    { field: 'accountFlag', headerName: 'Account Flag' },
  ];

  useEffect(() => {
    if (!selectedAccountTreatmentIndicator) {
      setAccountTreatmentIndicator(null);
      return;
    }
    setAccountTreatmentIndicator({
      ...selectedAccountTreatmentIndicator,
    });
  }, [selectedAccountTreatmentIndicator]);

  const master = (
    <>
      <ContentHeader>
        Account Treatment Indicators
        <button className={'ui button'} onClick={() => setSelectedAccountTreatmentIndicator(undefined)} disabled>
          Add New
        </button>
      </ContentHeader>
      <div style={{ height: 'calc(100% - 100px)' }}>
        <Table
          items={accountTreatmentIndicators}
          onSelectItem={setSelectedAccountTreatmentIndicator}
          columnDefs={columnDefs}
        />
      </div>
    </>
  );

  const detail = (
    <Segment>
      <ContentHeader>
        {accountTreatmentIndicator ? 'Account Treatment Indicator' : 'Add Account Treatment Indicator'}
      </ContentHeader>
      <AccountTreatmentIndicatorForm
        key={JSON.stringify(accountTreatmentIndicator)}
        accountTreatmentIndicator={accountTreatmentIndicator}
      />
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      <MasterDetailLayout master={master} detail={detail} />
    </ComponentErrorBoundary>
  );
}
